import { render, staticRenderFns } from "./ExpenseRuleBlock.vue?vue&type=template&id=49bdb91a&lang=pug&"
import script from "./ExpenseRuleBlock.vue?vue&type=script&lang=js&"
export * from "./ExpenseRuleBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports